// System / Light / Dark switch (ui/theme.ts). `labels` for the Account page; `icons` is the compact form for page
// corners (the sign-in screens), with the names kept for screen readers and as hover text.

import { Monitor, Moon, Sun } from 'lucide-react';
import type { ReactNode } from 'react';
import { SegmentedControl, type SegmentOption } from './SegmentedControl';
import { THEME_PREFERENCES, useTheme, type ThemePreference } from './theme';

export const THEME_LABELS: Record<ThemePreference, string> = { system: 'System', light: 'Light', dark: 'Dark' };

export const THEME_ICONS: Record<ThemePreference, ReactNode> = {
  system: <Monitor aria-hidden />,
  light: <Sun aria-hidden />,
  dark: <Moon aria-hidden />,
};

export interface ThemeSwitcherProps {
  variant?: 'labels' | 'icons';
  fullWidth?: boolean;
  className?: string;
}

export function ThemeSwitcher({ variant = 'labels', fullWidth = false, className }: ThemeSwitcherProps) {
  const { preference, setPreference } = useTheme();
  const iconsOnly = variant === 'icons';
  const options: SegmentOption<ThemePreference>[] = THEME_PREFERENCES.map((value) => ({
    value,
    icon: THEME_ICONS[value],
    label: THEME_LABELS[value],
  }));
  return (
    <SegmentedControl
      label="Appearance"
      value={preference}
      onChange={setPreference}
      options={options}
      size={iconsOnly ? 'sm' : 'md'}
      uppercase={false}
      iconOnly={iconsOnly}
      fullWidth={fullWidth}
      className={className}
    />
  );
}
